import { Typography } from '@mui/material';

export const FooterView = () => {

    return (
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
      >
        © 2023 Connected Parking
      </Typography>
    );
};
